module.exports = __webpack_public_path__ + "d0b1c9928db68b080830a82167b4474e.png";